module.exports = __webpack_public_path__ + "img/lightnin.3a0edfdd.png";